import { capitalize, startCase } from 'lodash';
import airtel from 'assets/images/airtel-wallet.svg';
import mtn from 'assets/images/mtn-wallet.svg';
import save from 'assets/images/save-wallet.svg';
import inkomoko from 'assets/images/wallet-inkomoko.svg';
import accessBank from 'assets/images/access-bank-wallet.svg';
import gtBank from 'assets/images/gt-bank-wallet.svg';
import keys from 'constants/walletKeys';

const getWalletLogo = name => {
  if (name?.toLowerCase()?.includes('mtn')) return mtn;
  if (name?.toLowerCase()?.includes('airtel')) return airtel;
  if (name?.toLowerCase()?.includes('access')) return accessBank;
  if (name?.toLowerCase()?.includes('gt')) return gtBank;
  if (name?.toLowerCase()?.includes('save')) return save;
  if (name?.toLowerCase()?.includes('inkomoko')) return inkomoko;
};

const sorter = ['org_name', 'access', 'gt', 'mtn', 'airtel'];

const onlyKeysAccepted = {
  save_country: {
    access_bank: [
      keys.individual_wallet_balance,
      keys.saving_group,
      keys.micro_loan_fund,
      keys.micro_loan_interest,
      keys.micro_loan_insurance,
      keys.transaction_fees,
      keys.wallet_fees,
      keys.group_transaction_fees,
      keys.save_float,
    ],
    gt_bank: [
      keys.individual_wallet_balance,
      keys.saving_group,
      keys.micro_loan_fund,
      keys.micro_loan_interest,
      keys.micro_loan_insurance,
      keys.transaction_fees,
      keys.wallet_fees,
      keys.group_transaction_fees,
      keys.save_float,
    ],
    mtn_rwanda: [
      keys.individual_wallet_balance,
      keys.saving_group,
      keys.save_float,
    ],
    airtel_rwanda: [
      keys.individual_wallet_balance,
      keys.saving_group,
      keys.save_float,
    ],
    save: [
      keys.individual_wallet_balance,
      keys.saving_group,
      keys.micro_loan_fund,
      keys.micro_loan_interest,
      keys.micro_loan_insurance,
      keys.transaction_fees,
      keys.wallet_fees,
      keys.group_transaction_fees,
      keys.save_float,
    ],
  },
  ngos: [keys.saving_group, keys.org_float],
};

const getWalletData = (data = [], orgType) =>
  data?.map(wallet => ({
    label: capitalize(startCase(wallet?.provider_name)),
    logo: getWalletLogo(wallet?.provider_name),
    balance: wallet?.balance || wallet?.total_balance,
    data: [
      {
        label: keys.individual_wallet_balance,
        value: wallet?.individual_wallet_balance,
        bold: true,
      },
      {
        label: keys.saving_group,
        value: wallet?.groups_balance,
        bold: true,
      },
      {
        label: keys.micro_loan_fund,
        value: wallet?.micro_loan_fund,
        bold: false,
      },
      {
        label: keys.micro_loan_interest,
        value: wallet?.micro_loan_interest,
        bold: false,
      },
      {
        label: keys.micro_loan_insurance,
        value: wallet?.micro_loan_insurance,
        bold: false,
      },
      {
        label: keys.transaction_fees,
        value: wallet?.fees,
        bold: true,
        hasSub: true,
        subs: [
          {
            label: keys.wallet_fees,
            value: wallet?.users_transactions_charge,
            bold: false,
          },
          {
            label: keys.group_transaction_fees,
            value: wallet?.groups_transactions_charge,
            bold: false,
          },
        ],
      },
      {
        label: keys.save_float,
        value: wallet?.float_balance,
        bold: true,
      },
      {
        label: keys.due_commissions,
        value: wallet?.due_commissions,
      },
    ].filter(detailedData => {
      const organizationKeys = onlyKeysAccepted[orgType];
      const acceptedKeys = Array.isArray(organizationKeys)
        ? organizationKeys
        : organizationKeys?.[wallet?.provider_name?.toLowerCase()];

      return acceptedKeys
        ? acceptedKeys.includes(detailedData.label)
        : true;
    }),
  }));

export default (data, orgType) => {
  const walletData = getWalletData(data, orgType);
  return sorter.map(item => {
    const wallet = walletData.find(data => {
      const label = data?.label?.toLowerCase();
      return item === 'org_name' ? true : label?.includes(item);
    });

    // Mark the organization's main wallet (SAVE) as the total wallet
    if (wallet && item === 'org_name') {
      return { ...wallet, isTotal: true };
    }

    return wallet;
  });
};
